import InvestStrategyApproveTable from './InvestStrategyApproveTable';

export default InvestStrategyApproveTable;
